import CrossCurrency from '@/App/tiles/TargetAccumulator/CrossCurrency.tsx';
import FixingReference1 from '@/App/tiles/TargetAccumulator/FixingReference1.tsx';
import FixingReference2 from '@/App/tiles/TargetAccumulator/FixingReference2.tsx';

export const InputGroup4 = () => (
  <>
    <CrossCurrency />
    <FixingReference1 />
    <FixingReference2 />
  </>
);
